import { FC, useEffect, useState } from "react";
import styles from './HomePage.module.less';
import Swiper from "../components/Swiper/Swiper";
import Announcement from "../components/Announcement";
import Entrance from '../components/Entrance';
import FileDownload from "../components/FileDownload";
import QuickLink from '../components/QuickLink';
import backgrond from '../assets/bg5.png';
import img1 from '../assets/1920-5.png';
import img2 from '../assets/1920-2.png';
import img3 from '../assets/1920-3.png';
import img4 from '../assets/1920-4.png';
import img5 from '../assets/1920-1.png';

const HomePage: FC = () => {
    const imap = {
        img1,
        img2,
        img3,
        img4,
        img5,
    }
    const [currentImg, setCurrentImg] = useState(img1);
    const getImage = (num) => {
        setCurrentImg(`img${num+1}`);
        // return `img-${num+1}`
    }
    return (
        <div className={styles.container}>
            <img style={{width: '100%', height: '480px', position: 'absolute', top: 0, filter: 'blur(20px)'}} src={imap[currentImg]} alt="" />
            <Swiper getImage={getImage}></Swiper>
            <div style={{width: '100%', height: '60px', zIndex: 1, backgroundColor: 'white'}}></div>
            <div className={styles.body}>
                <div className={styles.row}>
                    <div className={styles.announcement}>
                        <Announcement width={'836px'}></Announcement>
                    </div>
                    <div className={styles.entrance}>
                        <Entrance width={'320px'}></Entrance>
                    </div>
                </div>
                <div className={`${styles.row} ${styles['back-image']}`}>
                    <div className={styles.background}><img style={{width: '100%', height: '100%'}} src={backgrond} alt="" /></div>
                    <div style={{marginTop: '56px', display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <div className={styles.announcement}>
                            <FileDownload width={'836px'}></FileDownload>
                        </div>
                        <div className={styles.announcement}>
                            <QuickLink width={'320px'}></QuickLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;